import { useMutation } from '@tanstack/react-query';
import apiInputService from 'services/apiInputService';
import { SendReportPayload } from './@types';

const sendReports = async (params: SendReportPayload) => {
  const { data } = await apiInputService.get('/report/analyzes', {
    params: params,
  });

  return data;
};

export const useSendReports = (options?: any) => {
  return useMutation(sendReports, {
    ...options,
  });
};